import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaExclamationCircle } from 'react-icons/fa';

const ConfirmationDialog = (props) => {
  const [reportIdToArchive, setReportIdToArchive] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
     const user = JSON.parse(localStorage.getItem('currentUser'));
    setCurrentUser(user);
  }, []);

  const archiveReport = () => {
  };

  return (
    <Modal show={props.show} onHide={props.handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton={props.closeButton}>
        <Modal.Title className="w-100 text-start fw-bold fs-10 shadow-none">{props.header}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div className=" row d-flex justify-content-center mb-3">
          {props.icon&&(
             <FaExclamationCircle size={75} className="text-warning" />
          )}
          <h5 className=" w-100 text-center fs-10 fw-bold " style={{ color: 'var(--pmr-text-muted)' ,textTransform:'none',fontSize:'30px', textAlign: 'center'}}>{props.title}</h5>
        </div>
        {props.message}
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant="primary" onClick={props.onConfirm}>Yes</Button>
        <Button variant="danger" onClick={props.handleClose}>No</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationDialog;
